import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { EnvConfigService } from "app/env-config.service";
import { Observable } from "rxjs";

export type DynamicCsvReportSearchParams = Readonly<
  Record<string, string | readonly string[]>
>;

@Injectable({
  providedIn: "root",
})
export class GenerateReportService {
  private _httpClient = inject(HttpClient);
  envConfig = inject(EnvConfigService);

  downloadFeeCollectionReport(
    fromDate: string | null,
    toDate: string | null,
  ): Observable<HttpResponse<Blob>> {
    let params = new HttpParams();
    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }
    if (toDate) {
      params = params.set("toDate", toDate);
    }

    return this._httpClient.get(
      `${this.envConfig.envConfig.APIBASEURL}/api/application/excelReports/feeCollectionReport`,
      {
        params,
        responseType: "blob",
        observe: "response",
      },
    );
  }

  downloadDynamicCsvReport(
    productCategoryCode: string,
    reportCode: string,
    searchParams: DynamicCsvReportSearchParams = {},
  ): Observable<HttpResponse<Blob>> {
    let params = new HttpParams()
      .set("entityType", "eq:LOAN-APPLICATION")
      .set("productCategory", `eq:${productCategoryCode}`);

    Object.entries(searchParams).forEach(([key, value]) => {
      const values = typeof value === "string" ? [value] : value;
      values.forEach((searchValue) => {
        const trimmedValue = searchValue.trim();
        if (trimmedValue) {
          params = params.append(key, this.toSearchParamValue(trimmedValue));
        }
      });
    });

    return this._httpClient.get(
      `${this.envConfig.envConfig.APIBASEURL}/api/application/excelReports/csv/${encodeURIComponent(productCategoryCode)}/${encodeURIComponent(reportCode)}`,
      {
        params,
        responseType: "blob",
        observe: "response",
      },
    );
  }

  private toSearchParamValue(value: string): string {
    return /^(eq|like|gte|gt|lte|lt|in):/.test(value) ? value : `like:${value}`;
  }
}
